import { isAuthenticated } from '../utils/authHelper';
import React, { Fragment } from 'react'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog';
import WaringIcon from '@material-ui/icons/Warning'
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContentText from '@material-ui/core/DialogContentText';
import { MuiThemeProvider } from '@material-ui/core/styles'
import { createMuiTheme } from '@material-ui/core/styles'
import RaisedButton from 'material-ui/RaisedButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import Checkbox from 'material-ui/Checkbox';
import Snackbar from '@material-ui/core/Snackbar'
import { browserHistory } from 'react-router'
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { onboardPaymentRequest, updatePaymentRequest, validatePaymentRequest, calculateAdvancePaid, holdPaymentRequest } from '../utils/PaymentRequestApiUtils'
import moment from 'moment';
import { DialogActions } from '@material-ui/core';
import { viewBlobFile, viewLinkInNewWindow, viewFile } from './viewFileUtilFunction'
import { getGstTypeName } from '../utils/globalUtils';
import { businessUnitMap } from '../constants/paymentStatus';
const constants = require('../config/constants');
const theme = createMuiTheme({
  overrides: {
    MuiListItemText: {
      root: {
        padding: '0px'
      }
    }
  }
});

class PreviewAndCalculations extends React.Component {
  constructor(props) {
    super(props)
    if (!isAuthenticated()) {
      browserHistory.push('/')
    }
    this.state = {
      total_invoice_amount: 0,
      total_sgst_amount: 0,
      total_cgst_amount: 0,
      total_igst_amount: 0,
      total_ugst_amount: 0,
      total_gst_amount: 0,
      total_tds_deduction: 0,
      total_deduction_others: 0,
      total_discount: 0,
      advance_paid: 0,
      total_payable_amount: 0,
      dialogBox: false,
      dialogBoxText: '',
      advanceAlertBoxText: '',
      advanceAlertBox: false,
      confrmAmountDialog: false,
      confrmAmountDialogText: '',
      status: undefined,
      invoice_amount_checked: false,
      total_payable_amount_checked: false,
      paymentDetails: undefined,
      prId: '',
      bsId: '',
      cost_center_entries: {
        entries: [],
        deleted_entries: [],
        invoice_copy: '',
        gst_type: '',
        gst_avail_type: '',
        is_recoverable: '',
        amt_recoverable: '',
        amt_recoverable_per_agreement: '',
        amt_recoverable_proof_file: null,
        amt_recoverable_proof_file_name: '',
        recoverable_amount_remarks: '',
      },
      snackOpen: false,
      snackText: '',
      inRequest: false,
      advance_paid_for_non_final: 0,
      approveDialogBox: false,
      approveddialogBoxTitle: '',
      approveddialogBoxText: '',
      paymentStatus: '',
      vendorWaringModal: false,
      comment: '',
      commentErr: false,
      commentErrText: '',
      vendorErrorObj: {
        flag: false,
        errors: []
      },
      buList: businessUnitMap || []
    }
    this.handleSubmitYes = this.handleSubmitYes.bind(this);
  }
  componentDidMount(props) {
    if (this.props.data && this.props.data.paymentDetails && this.props.data.cost_center_entries) {
      this.props.data.cost_center_entries.entries.forEach(ccae => {
        let ccae_tds_deduction = 0;
        let ccae_discount = 0;
        ccae.gst_splits.forEach(gam => {
          ccae_tds_deduction += gam.tds_deduction;
          ccae_discount += parseFloat(gam.discount);
        })
        ccae.tds_deduction = ccae_tds_deduction;
        ccae.discount = ccae_discount;
      });
      if (this.props.data.paymentDetails.po_number && this.props.data.paymentDetails.po_number != '') {
        calculateAdvancePaid(this.props.data.paymentDetails.po_number, this.props.data.paymentDetails.vendor_code).then((response) => {
          if (response) {
            if (response.status === 'success') {
              let advance_paid = 0
              if (response.data.advance_paid)
                advance_paid = response.data.advance_paid

              if (this.props.data.paymentDetails.type_of_payment === "Final Settlement") {
                this.setState({ advance_paid: advance_paid ? advance_paid : 0 }, () => {
                  this.setAdvancedPaid(this.state.advance_paid)
                })
              }
              else if (this.props.data.paymentDetails.type_of_payment === "Advance Against PO") {
                this.setState({ advance_paid_for_non_final: advance_paid })
              }
            }
          }
        })
      }
      this.setState({
        paymentDetails: this.props.data.paymentDetails,
        cost_center_entries: this.props.data.cost_center_entries,
        status: this.props.data.status,
        prId: this.props.data.paymentDetails.payment_request_id || '',
        bsId: this.props.data.paymentDetails.bs_Id || ''
      }, () => {
        let total_invoice_amount = 0, total_sgst_amount = 0, total_cgst_amount = 0, total_igst_amount = 0,
          total_discount = 0, total_tds_deduction = 0, total_deduction_others = 0, total_ugst_amount = 0, total_gst_amount = 0;
        this.props.data.cost_center_entries.entries.map(data => {
          total_invoice_amount = total_invoice_amount + parseFloat(data.invoice_amount)
          total_sgst_amount = total_sgst_amount + parseFloat(data.sgst_amount)
          total_cgst_amount = total_cgst_amount + parseFloat(data.cgst_amount)
          total_igst_amount = total_igst_amount + parseFloat(data.igst_amount)
          total_ugst_amount = total_ugst_amount + parseFloat(data.ugst_amount)
          total_gst_amount = total_sgst_amount + total_cgst_amount + total_igst_amount + total_ugst_amount
          total_tds_deduction = total_tds_deduction + parseFloat(data.tds_deduction !== undefined ? data.tds_deduction : (data.tds_deductions === null ? 0 : data.tds_deductions))
          total_deduction_others = total_deduction_others + parseFloat(data.deduction_others)
          total_discount = total_discount + parseFloat(data.discount)
        })
        this.setState({
          total_invoice_amount, total_sgst_amount, total_cgst_amount, total_igst_amount, total_tds_deduction
          , total_deduction_others, total_discount, total_ugst_amount, total_gst_amount,
          total_payable_amount: +(total_invoice_amount + total_sgst_amount + total_cgst_amount + total_igst_amount +
            total_ugst_amount - total_discount - total_tds_deduction - total_deduction_others - this.state.advance_paid).toFixed(2)
        }, () => this.isVendorError())
      }, () => this.isVendorError())
    }
    else if (this.props.previewData) {
      let state = { ...this.state, ...this.props.previewData }
      state.paymentDetails.date_of_invoice = new Date(state.paymentDetails.date_of_invoice)
      state.paymentDetails.expenditure_month = state.paymentDetails.expenditure_month.split(',')
      state.paymentDetails.expenditure_start_date = new Date(state.paymentDetails.expenditure_start_date)
      state.paymentDetails.expenditure_end_date = new Date(state.paymentDetails.expenditure_end_date)
      state.advance_paid = state.advance_paid === null ? 0 : state.advance_paid;
      state.prId = state.payment_request_id;
      state.bsId = state.bill_submission_data ? state.bill_submission_data.bs_Id : '';
      this.setState({ ...state }, () => this.isVendorError())
    }
  }
  handleClose() {
    if (typeof this.state.paymentDetails.prevPath !== 'undefined') {
      browserHistory.push(this.state.paymentDetails.prevPath);
    }
    else {
      window.location.reload();
    }
  }

  isVendorError = () => {
    const errorObj = {
      flag: false,
      errors: []
    };

    if (this.state.vendor_deactivate || (this.state.paymentDetails && this.state.paymentDetails.vendor_deactivate)) {
      errorObj.flag = true;
      errorObj.errors.push({
        name: 'Vendor Deactivated',
        message: 'Vendor is deactivated',
        renderVal: (
          <span>Yes</span>
        )
      });
    }

    if (this.state.agreement_expiry_date || (this.state.paymentDetails && this.state.paymentDetails.agreement_expiry_date)) {
      const agreementExpiryDate = new Date(this.state.agreement_expiry_date || this.state.paymentDetails.agreement_expiry_date);
      agreementExpiryDate.setHours(0, 0, 0, 0); // Set time to 0
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0); // Set time to 0

      // Check if agreement only expiry date is less than current date and if yes, then show error
      if (agreementExpiryDate < currentDate) {
        errorObj.flag = true;
        errorObj.errors.push({
          name: 'Vendor Agreement Expired On',
          message: 'Agreement expired',
          renderVal: (
            <span>{agreementExpiryDate.toDateString()}</span>
          )
        });
      }
    }

    if (this.state.defaultor_amount > 0 || (this.state.paymentDetails && this.state.paymentDetails.defaultor_amount > 0)) {
      errorObj.flag = true;
      errorObj.errors.push({
        name: 'Vendor Defaulted Amount',
        message: 'Vendor has defaulted amount',
        renderVal: (
          <span>{this.state.defaultor_amount || this.state.paymentDetails.defaultor_amount}</span>
        )
      })
    }

    if (this.state.paymentDetails && this.state.paymentDetails.vendor_ldc_data && this.state.paymentDetails.vendor_ldc_data.length > 0) {
      for (let vendorLdcData of this.state.paymentDetails.vendor_ldc_data) {
        if (vendorLdcData.ldc_amount_limit > 0) {
          errorObj.flag = true;
          errorObj.errors.push({
            name: vendorLdcData.section_name,
            message: 'Vendor has LDC amount limit',
            renderVal: (
              <div>
                <span>{`LDC Limit: \u20B9 ${vendorLdcData.ldc_amount_limit}`}</span><br />
                <span>LDC Rate: {vendorLdcData.ldc_rate}</span>
              </div>
            )
          })
        }
      }
    }

    if (this.state.pancard_status == '0' || (this.state.paymentDetails && this.state.paymentDetails.pancard_status == '0')) {
      errorObj.flag = true;
      errorObj.errors.push({
        name: 'Pancard Status',
        message: 'Pancard Inoperative',
        renderVal: (
          <span>{"Inoperative"}</span>
        )
      });
    }

    if ((this.state.gstn_status == 'CANCELLED' || this.state.gstn_status == 'SUSPENDED') || (this.state.paymentDetails && (this.state.paymentDetails.gstn_status == 'CANCELLED' || this.state.paymentDetails.gstn_status == 'SUSPENDED'))) {
      errorObj.flag = true;
      errorObj.errors.push({
        name: 'GST Status',
        message: 'GST is not active',
        renderVal: (
          <span>{this.state.gstn_status || this.state.paymentDetails.gstn_status}</span>
        )
      });
    }

    this.setState({ vendorErrorObj: errorObj });
  }

  setAdvancedPaid(value) {
    let re = new RegExp('^[+]?([0-9]+(?:[\\.][0-9]*)?|\\.[0-9]+)$');
    let inputVal = "" + value;
    if ((!re.test(inputVal) && inputVal !== '') || isNaN(inputVal))
      return false;
    let totalPayableAmount = this.state.total_invoice_amount + this.state.total_sgst_amount + this.state.total_cgst_amount + this.state.total_igst_amount + this.state.total_ugst_amount - this.state.total_discount - this.state.total_tds_deduction - this.state.total_deduction_others - value;
    if (totalPayableAmount < 0) {
      this.setState({ advanceAlertBoxText: "Final Settlement amount should be greater than " + value + " (advance amount already paid", advanceAlertBox: true });
    }
    let advancePaid = value;
    if (value === '')
      advancePaid = 0;
    this.setState({
      advance_paid: advancePaid,
      total_payable_amount: +(totalPayableAmount).toFixed(2)
    })
  }

  handleSubmit(value) {
    this.value = value;
    /*disabling the submit button*/
    this.setState({ inRequest: true });
    if (this.state.total_payable_amount > 200000) {
      this.setState({ confrmAmountDialog: true, confrmAmountDialogText: "You're submitting a request for more than two lakh rupees. Are you sure you want to continue?" })
    }
    else {
      this.handleSubmitYes(value);
    }
  }

  async handleSubmitYes() {
    this.setState({ confrmAmountDialog: false })
    let value = this.value;
    if (this.state.invoice_amount_checked && this.state.total_payable_amount_checked) {
      this.props.removeTdsRateCheck();
      if (this.state.status !== 'edit') {
        if (this.props.data.paymentDetails.type_of_payment == "Final Settlement") {
          const dateOfInvoice = this.props.data.paymentDetails.date_of_invoice ? new Date(this.props.data.paymentDetails.date_of_invoice) : null;
          let validationResponse = await validatePaymentRequest(this.state.paymentDetails.vendor_code, this.state.paymentDetails.invoice_number, dateOfInvoice)
          if (validationResponse) {
            if (validationResponse.status !== 'success') {
              this.setState({ snackText: validationResponse.message, snackOpen: true })
              return false
            }
          }
        }
      }
      let response
      let data = {
        ...this.state.paymentDetails,
        date_of_invoice: moment(this.state.paymentDetails.date_of_invoice).format('YYYY-MM-DD'),
        gst_type: this.state.cost_center_entries.gst_type,
        gst_avail_type: this.state.cost_center_entries.gst_avail_type,
        is_recoverable: this.state.cost_center_entries.is_recoverable,
        amount_recoverable: this.state.cost_center_entries.amount_recoverable,
        as_per_agreement: this.state.cost_center_entries.as_per_agreement,
        recoverable_amount_remarks: this.state.cost_center_entries.recoverable_amount_remarks,
        defaultor_amount_deduction: this.state.cost_center_entries.defaultor_amount_deduction || 0,
        amt_recoverable_proof_file_name: this.state.cost_center_entries.amt_recoverable_proof_file_name,
        po_soft_copy_file: this.state.paymentDetails.po_soft_copy_file,
        ...this.state,
        cost_center_entries: JSON.stringify(this.state.cost_center_entries),
        status: value
      }
      delete data.paymentDetails
      let formData = new FormData()
      formData.append('recoverable_amount_proof_link', this.state.cost_center_entries.amt_recoverable_proof_file)
      Object.keys(data).map(key => {
        formData.append(key, data[key])
      })
      switch (value) {
        case 'hold':
        case 'update': {
          response = await updatePaymentRequest(formData)
          break;
        }
        default: {
          response = await onboardPaymentRequest(formData)
        }
      }
      /*enable the submit button*/
      this.setState({ inRequest: false });
      this.setState({ dialogBox: true, dialogBoxText: response.message })
    }
    else {
      this.setState({ inRequest: false, snackOpen: true, snackText: 'Please Checklist all payable properties' })
    }
  }
  updateCheck(props) {
    this.setState({ [props]: !this.state[props] })
  }
  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }
  //Verify validity of the invoice url (soft copy link)
  validURL(str) {
    var pattern = constants.urlRegxp;
    return !!pattern.test(str);
  }

  openApproveDialogBox = async (status) => {
    this.setState({
      approveDialogBox: true,
      approveddialogBoxTitle: `Are you sure you want to ${status == 'hold' ? 'hold' : 'release'} this payment request?`,
      approveddialogBoxText: `Please enter the comments for ${status == 'hold' ? 'hold' : 'releas'}ing the payment request`,
      paymentStatus: status
    })
  }

  handleNo = () => {
    this.setState({
      approveDialogBox: false,
      approveddialogBoxTitle: '',
      approveddialogBoxText: '',
      paymentStatus: '',
      comment: '',
      commentErr: false,
      commentErrText: ''
    })
  };

  handleYes = async () => {
    const { comment } = this.state;
    if (comment === undefined || comment === '') {
      this.setState({ commentErr: true, commentErrText: 'Please enter the comments' });
      return;
    };

    const payload = {
      paymentRequestId: this.state.paymentDetails.payment_request_id,
      status: this.state.paymentStatus ? this.state.paymentStatus : 'pending',
      reason: comment,
    }
    this.handleNo();
    const response = await holdPaymentRequest(payload);

    this.setState({
      dialogBox: true,
      dialogBoxText: response.message,
      comment: '',
      commentErr: false,
      commentErrText: ''
    });
  }

  handleComment = (event) => {
    this.setState({ comment: event.target.value });
  }

  clearErr = () => {
    this.setState({ commentErr: false, commentErrText: '' })
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        {this.state.paymentDetails !== undefined && <Grid item xs={12} md={6}>
          <List>
            <div style={{ display: 'flex' }}>
              <div style={{ width: '100%' }}>
                <ListItem style={{ position: 'relative' }}>
                  <ListItemText style={{ minWidth: '170px' }} primary=" Vendor name" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.paymentDetails.vendor_name} />
                  {this.state.vendorErrorObj.flag && (
                    <WaringIcon
                      style={{
                        color: '#FF0000',
                        position: 'absolute',
                        right: '0',
                        bottom: '1rem',
                        cursor: 'pointer'
                      }}
                      onClick={() => this.setState({ vendorWaringModal: true })}
                    />
                  )}
                </ListItem>
                <ListItem>
                  <ListItemText style={{ minWidth: '170px' }} primary=" PR Index" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.prId}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText style={{ minWidth: '170px' }} primary=" Type of Payment" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.paymentDetails.type_of_payment}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText style={{ minWidth: '170px' }} primary="Invoice/PV Number " />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.paymentDetails.invoice_number}

                  />
                </ListItem>
                {/* --- Invoice soft copy --- */}
                {(() => {
                  const invoiceLink = this.state.paymentDetails.invoice_soft_copy_link;
                  const sdLink = this.state.paymentDetails.supporting_document_link;

                  // Parse supporting_document_link as JSON array (new-zaps) or treat as plain URL
                  let sdDocs = [];
                  try {
                    const parsed = JSON.parse(sdLink);
                    if (Array.isArray(parsed)) sdDocs = parsed;
                  } catch (e) {
                    if (sdLink && this.validURL(sdLink)) sdDocs = [sdLink];
                  }

                  const hasInvoice = invoiceLink && invoiceLink !== '' && this.validURL(invoiceLink);

                  // If no invoice link but we have attachment docs (new-zaps), use first doc as invoice
                  const effectiveInvoiceLink = hasInvoice ? invoiceLink : (sdDocs.length > 0 ? sdDocs[0] : null);
                  // Remaining docs shown as supporting documents (skip first if it was promoted to invoice)
                  const remainingDocs = hasInvoice ? sdDocs : sdDocs.slice(1);

                  return (
                    <Fragment>
                      {this.state.paymentDetails.type_of_payment === 'Final Settlement' && effectiveInvoiceLink && (
                        <ListItem>
                          <button style={{ marginLeft: '180px' }} onClick={() => viewLinkInNewWindow(effectiveInvoiceLink)}>
                            View Invoice
                          </button>
                        </ListItem>
                      )}
                      {remainingDocs.map((link, i) => (
                        <ListItem key={i}>
                          <button style={{ marginLeft: '180px' }} onClick={() => viewLinkInNewWindow(link)}>
                            View Attachment {i + 1}
                          </button>
                        </ListItem>
                      ))}
                    </Fragment>
                  );
                })()}
                <ListItem>
                  <ListItemText style={{ minWidth: '170px' }} primary="Expenditure of month" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.paymentDetails.expenditure_month.join(', ')}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText style={{ minWidth: '170px' }} primary="Expenditure start date" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.paymentDetails.expenditure_start_date ? this.state.paymentDetails.expenditure_start_date.toDateString() : ''}
                  />
                </ListItem>
                {<ListItem>

                  <ListItemText style={{ minWidth: '170px' }} primary="L1 Approver Comments" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.paymentDetails.cityHeadComments}
                  />
                </ListItem>}
              </div>
              <div style={{ width: '100%' }}>
                <ListItem>
                  <ListItemText style={{ minWidth: '170px' }} primary="PO Number" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.paymentDetails.po_number}
                  />
                </ListItem>
                {this.state.paymentDetails.partial_payment_percentage && (
                  <React.Fragment>
                    <ListItem>
                      <ListItemText style={{ minWidth: '170px' }} primary="Payment Status" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      <ListItemText style={{ minWidth: '240px' }} primary={
                        <span style={{
                          backgroundColor: this.state.paymentDetails.type_of_payment === 'Final Settlement' ? '#4CAF50' : '#FF9800',
                          color: 'white',
                          padding: '2px 8px',
                          borderRadius: '4px',
                          fontSize: '12px',
                          fontWeight: 'bold'
                        }}>
                          {this.state.paymentDetails.type_of_payment === 'Final Settlement'
                            ? 'Settlement Completed'
                            : `Partial Payment (${this.state.paymentDetails.partial_payment_percentage}%)`}
                        </span>
                      } />
                    </ListItem>
                    <ListItem>
                      <ListItemText style={{ minWidth: '170px' }} primary="Full Invoice Amount" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }}
                        primary={`₹ ${parseFloat(this.state.paymentDetails.full_invoice_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`} />
                    </ListItem>
                  </React.Fragment>
                )}
                {this.state.paymentDetails.amount_increase_warning && (
                  <ListItem>
                    <div style={{
                      width: '100%',
                      backgroundColor: '#FFEBEE',
                      border: '1px solid #EF5350',
                      borderRadius: '8px',
                      padding: '12px 16px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px'
                    }}>
                      <span style={{
                        backgroundColor: '#D32F2F',
                        color: 'white',
                        padding: '2px 10px',
                        borderRadius: '12px',
                        fontSize: '11px',
                        fontWeight: 'bold',
                        whiteSpace: 'nowrap'
                      }}>
                        ⚠️ Amount Exceeded
                      </span>
                      <span style={{ color: '#B71C1C', fontSize: '13px' }}>
                        {this.state.paymentDetails.amount_increase_warning}
                      </span>
                    </div>
                  </ListItem>
                )}
                <ListItem>
                  <ListItemText style={{ minWidth: '170px' }} primary=" Bill Submission Id" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.bsId}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText style={{ minWidth: '170px' }} primary=" Business Unit" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }}
                    primary={
                      (this.state.buList[this.state.paymentDetails.business_unit] && this.state.buList[this.state.paymentDetails.business_unit].value)
                      || this.state.paymentDetails.business_unit
                      || ''
                    }
                  />
                </ListItem>
                {this.state.paymentDetails.type_of_payment === 'Advance Against PO' && this.state.paymentDetails.invoice_soft_copy_link !== '' && this.state.paymentDetails.invoice_soft_copy_link !== null &&
                  this.state.paymentDetails.po_number !== '' &&
                  <ListItem>
                    {
                      (this.state.paymentDetails.po_soft_copy_file !== undefined) ?
                        <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{ 'backgroundColor': 'rgb(0,188,212)', 'height': '20px', 'color': 'white' }} onClick={() => viewBlobFile(this.state.paymentDetails.po_soft_copy_file)}>View Purchase Order</Button>} /> :
                        null
                    }
                    {(this.state.paymentDetails.po_soft_copy_file === undefined) ?
                      (this.state.paymentDetails.invoice_soft_copy_link) ?
                        <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{ 'backgroundColor': 'rgb(0,188,212)', 'height': '20px', 'color': 'white' }} onClick={() => viewFile(this.state.paymentDetails.invoice_soft_copy_link)}>View Purchase Order</Button>} /> : null
                      : null
                    }
                  </ListItem>
                }
                <ListItem>
                  <ListItemText style={{ minWidth: '170px' }} primary="Date of Invoice" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.paymentDetails.date_of_invoice.toDateString()}
                  />
                </ListItem>

                <ListItem>
                  <ListItemText style={{ minWidth: '170px' }} primary="Mode of Payment" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.paymentDetails.mode_of_payment}
                  />
                </ListItem>

                <ListItem>

                  <ListItemText style={{ minWidth: '170px' }} primary="Narration" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.paymentDetails.narration}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText style={{ minWidth: '170px' }} primary="Expenditure end date" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.paymentDetails.expenditure_end_date ? this.state.paymentDetails.expenditure_end_date.toDateString() : ''}
                  />
                </ListItem>
                <ListItem>

                  <ListItemText style={{ minWidth: '170px' }} primary="L2 Approver Comments" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.paymentDetails.centralFinanceComments}
                  />
                </ListItem>
              </div>
            </div>
          </List>
        </Grid>}
        <div style={{ display: 'flex', gap: '5rem' }}>
          {/* <FormControl margin='normal' style={{ marginLeft: '15px' }}>
            <InputLabel htmlFor="gst_slab">GST Type</InputLabel>
            <Select
              value={this.state.cost_center_entries.gst_type}
              style={{ width: '150px', textAlign: 'left' }}
              disabled={true}
            >
              <MenuItem value={this.state.cost_center_entries.gst_type}>{getGstTypeName(this.state.cost_center_entries.gst_type)}</MenuItem>
            </Select>
          </FormControl> */}
          <div title={getGstTypeName(this.state.cost_center_entries.gst_type)} style={{ display: 'inline-block' }}>
            <TextField
              label="GST Type"
              value={getGstTypeName(this.state.cost_center_entries.gst_type)}
              margin='normal'
              style={{ width: '250px' }}
              inputProps={{
                style: {
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  width: '250px'
                }
              }}
            />
          </div>
          <TextField
            label="GST Availment type"
            value={this.state.cost_center_entries.gst_avail_type}
            style={{ width: '250px' }}
            margin='normal'
          />
        </div>
        {this.state.cost_center_entries.entries.map((data, index) => {
          return (<ExpansionPanel style={{ marginRight: '68px' }}>
            <ExpansionPanelSummary style={{ backgroundColor: 'lightgray' }} expandIcon={<ExpandMoreIcon />}>
              <Typography >Cost Center Details {index + 1}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div>
                <TextField
                  label='Entity'
                  value={data.entity_nameSearchText}
                  margin='normal'
                  style={{ width: '520px' }}
                />
                {data.gst_splits.map((gst_data, gst_index) => {
                  return <div style={{ display: 'grid', gridTemplateColumns: '100%' }}>
                    <div style={{ overflow: 'scroll', whiteSpace: 'nowrap' }}>
                      <div title={gst_data.ledger_name} style={{ display: 'inline-block' }}>
                        <TextField
                          label="Ledger Name"
                          value={gst_data.ledger_name}
                          margin='normal'
                          style={{ width: '500px' }}
                          inputProps={{
                            style: {
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              width: '500px'
                            }
                          }}
                        />
                      </div>
                      <TextField
                        label={`Amount ${gst_index + 1}`}
                        value={gst_data.amount}
                        margin='normal'
                        style={{ width: '150px', marginLeft: '15px' }}
                      />
                      <TextField
                        label='GST Slab'
                        value={gst_data.gst_slab}
                        margin='normal'
                        style={{ width: '150px', marginLeft: '15px' }}
                      />
                      <TextField
                        label='TDS Slab'
                        value={gst_data.tds_slab}
                        margin='normal'
                        style={{ width: '150px', marginLeft: '15px' }}
                      />
                      <TextField
                        label="Deductions"
                        value={gst_data.other_deduction}
                        style={{ width: '150px', marginLeft: '15px' }}
                        margin='normal'

                      />
                      <TextField
                        label="Discount"
                        value={gst_data.discount}
                        margin='normal'
                        style={{ width: '150px', marginLeft: '15px' }}
                      />
                      <TextField
                        label="Quantity"
                        value={gst_data.quantity}
                        margin='normal'
                        style={{ width: '150px', marginLeft: '15px' }}
                      />
                      <TextField
                        label="Rate"
                        value={gst_data.rate}
                        margin='normal'
                        style={{ width: '150px', marginLeft: '15px' }}
                      />
                      <TextField
                        label="Item Name"
                        value={gst_data.item_name}
                        margin='normal'
                        style={{ width: '150px', marginLeft: '15px' }}
                      />
                      <TextField
                        label="Desc"
                        value={gst_data.item_description}
                        margin='normal'
                        style={{ width: '150px', marginLeft: '15px' }}
                      />
                      <TextField
                        label="HSN"
                        value={gst_data.hsn || ''}
                        margin='normal'
                        style={{ width: '150px', marginLeft: '15px' }}
                      />
                      <TextField
                        label="SAC"
                        value={gst_data.sac || ''}
                        margin='normal'
                        style={{ width: '150px', marginLeft: '10px' }}
                      />
                      <TextField
                        label="Currency"
                        value={gst_data.currency}
                        margin='normal'
                        style={{ width: '150px', marginLeft: '15px' }}
                      />
                    </div>
                  </div>
                })}
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          )
        })}
        <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
          {this.state.cost_center_entries.invoice_copy && <TextField
            label="Drive Link for soft copy of invoice"
            value={this.state.cost_center_entries.invoice_copy}
            style={{ width: '250px' }}
            margin='normal'
          />}
          <TextField
            label="IS RECOVERABLE"
            value={this.state.cost_center_entries.is_recoverable === true ? 'Yes' : 'No'}
            style={{ width: '250px' }}
            margin='normal'
          />
        </div>
        {this.state.cost_center_entries.is_recoverable === true &&
          <div>
            <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
              <TextField
                label="Amount recoverable"
                value={this.state.cost_center_entries.amount_recoverable}
                style={{ width: '250px' }}
                margin='normal'
              />
              <TextField
                label="As per Agreement"
                value={this.state.cost_center_entries.as_per_agreement === true ? 'Yes' : 'No'}
                style={{ width: '250px', marginLeft: '20px' }}
                margin='normal'
              />

            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
              {this.state.cost_center_entries.amt_recoverable_per_agreement === false && <div>
                <div >
                  {this.state.cost_center_entries.amt_recoverable_proof_file_name && <TextField
                    label=" Any proof"
                    value={this.state.cost_center_entries.amt_recoverable_proof_file_name}
                    margin='normal'
                    style={{ width: '250px' }}
                  />}
                </div>
                {this.state.cost_center_entries.recoverable_amount_remarks && <TextField
                  label="Comments"
                  value={this.state.cost_center_entries.recoverable_amount_remarks}
                  margin='normal'
                  style={{ width: '520px' }}

                />}</div>}
            </div></div>}
        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '20px' }}>
          <TextField
            label="Total Taxable amount"
            value={this.state.total_invoice_amount}
            style={{ width: '250px' }}

          />
          {(this.state.status === 'onboard' || this.state.status === 'edit') && <Checkbox
            checked={this.state.invoice_amount_checked}
            onCheck={this.updateCheck.bind(this, 'invoice_amount_checked')}
            style={{ marginLeft: '20px', marginTop: 'auto', width: 'auto' }}
          />}
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <TextField
            label="SGST"
            value={this.state.total_sgst_amount}
            margin='normal'
            style={{ width: '250px' }}

          />
          <TextField
            label="CGST"
            value={this.state.total_cgst_amount}
            margin='normal'
            style={{ width: '250px', marginLeft: '20px' }}

          />
          <TextField
            label="IGST"
            value={this.state.total_igst_amount}
            margin='normal'
            style={{ width: '250px' }}

          />

          <TextField
            label="UGST"
            value={this.state.total_ugst_amount}
            margin='normal'
            style={{ width: '250px', marginLeft: '20px' }}

          /><br />
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}>
          <TextField
            label="Total GST amount"
            value={this.state.total_gst_amount}
            style={{ width: '250px' }}
          />
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '20px' }}>
          <TextField
            label="Total Invoice amount"
            value={this.state.total_invoice_amount + this.state.total_gst_amount}
            style={{ width: '250px' }}
          />
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <TextField
            label="TDS Deduction"
            margin='normal'
            value={this.state.total_tds_deduction.toFixed(2)}
            style={{ width: '250px' }}

          />
          <TextField
            label="Deduction other than TDS"
            margin='normal'
            value={this.state.total_deduction_others}
            style={{ width: '250px', marginLeft: '20px' }}

          />
          <TextField
            label="Discount"
            margin='normal'
            value={this.state.total_discount}
            style={{ width: '250px', marginLeft: '20px' }}

          />
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <TextField
            label="Advance Paid"
            value={(this.state.advance_paid_for_non_final === 0) ? this.state.advance_paid : this.state.advance_paid_for_non_final}
            type='text'
            margin='normal'
            InputProps={{ inputProps: { min: 0 } }}
            style={{ width: '250px' }}

          />
          {this.state.defaultor_amount > 0 || (this.state.paymentDetails && this.state.paymentDetails.defaultor_amount > 0) ? (
            <TextField
              label="Total Amount deducted for Defaultor Amount"
              placeholder="Enter total amount deducted from Vendor's Defaultor Amount"
              value={String(this.state.cost_center_entries.defaultor_amount_deduction || '')}
              type='number'
              margin='normal'
              style={{ width: '450px', marginLeft: '15px' }}
            />
          ) : null}
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <TextField
            label="Net Payable amount"
            margin='normal'
            value={this.state.total_payable_amount < 0 ? this.setState({ total_payable_amount: 0 }) : this.state.total_payable_amount}
            style={{ width: '250px' }}

          />
          {(this.state.status === 'onboard' || this.state.status === 'edit') && <Checkbox
            checked={this.state.total_payable_amount_checked}
            onCheck={this.updateCheck.bind(this, 'total_payable_amount_checked')}
            style={{ marginLeft: '20px', marginTop: 'auto', width: 'auto' }}
          />}
        </div>
        {(this.state.status === 'onboard' || this.state.status === 'edit') && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexWrap: 'wrap',
              marginTop: '40px',
              marginBottom: '40px'
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={this.props.handleBack.bind(this, this.state.advance_paid)}
              buttonStyle={{ backgroundColor: 'red' }}
              disabled={this.state.inRequest}
              style={{ marginLeft: '20px' }}
            >Back</Button>
            {this.state.status === 'onboard' && (
              <div>
                {/* <Button style={{ marginLeft: '20px' }} variant="contained" color="primary" onClick={this.handleSubmit.bind(this, 'draft')}>
              Send to Draft
                  </Button> */}
                <Button
                  style={{
                    marginLeft: '20px',
                    color: 'white',
                    backgroundColor: this.state.inRequest ? 'grey' : 'rgb(121,183,79)'
                  }}
                  variant="contained"
                  disabled={this.state.inRequest}
                  onClick={this.handleSubmit.bind(this, 'pending')}
                >
                  Send for Approval
                </Button>
              </div>
            )}
            {this.state.status === 'edit' && (
              <Fragment>
                <Button
                  style={{
                    marginLeft: '20px',
                    color: 'white',
                    backgroundColor: (this.state.inRequest) ? 'grey' : 'rgb(121,183,79)'
                  }}
                  variant="contained"
                  disabled={this.state.inRequest}
                  onClick={this.handleSubmit.bind(this, 'update')}
                >
                  Send changes for approval
                </Button>
                {/* {(this.state.paymentDetails.payment_status == 'hold' || this.state.paymentDetails.payment_status == 'pending') && (
                <Button 
                  style={{ 
                    marginLeft: '20px', 
                    color: 'white', 
                    backgroundColor: this.state.inRequest ? 'grey' : 'rgb(255, 165, 0)'
                  }} 
                  variant="contained" 
                  disabled={this.state.inRequest} 
                  onClick={() => this.openApproveDialogBox(this.state.paymentDetails.payment_status == 'hold' ? 'pending' : 'hold')}
                >
                  {this.state.paymentDetails.payment_status == 'hold' ? "Release Payment Request" : "Hold Payment Request"}
                </Button>
              )} */}
                {this.state.paymentDetails.payment_status == 'pending' && (
                  <Button
                    style={{
                      marginLeft: '20px',
                      color: 'white',
                      backgroundColor: this.state.inRequest ? 'grey' : 'rgb(255, 165, 0)'
                    }}
                    variant="contained"
                    disabled={this.state.inRequest}
                    onClick={() => this.openApproveDialogBox('hold')}
                  >
                    Hold Payment Request
                  </Button>
                )}
              </Fragment>
            )}
          </div>
        )}
        <Dialog
          modal={false}
          open={this.state.dialogBox}
          onClose={this.handleClose.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <h4 style={{ textAlign: 'center' }}>{this.state.dialogBoxText}</h4>
            </DialogContentText>
          </DialogContent>
          <RaisedButton primary={true} onClick={this.handleClose.bind(this)} label="OK" />
        </Dialog>
        {(this.state.status === 'onboard' || this.state.status === 'edit') &&
          <Dialog
            modal={false}
            open={this.state.advanceAlertBox}
            onClose={this.handleClose.bind(this)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <h4 style={{ textAlign: 'center' }}>{this.state.advanceAlertBoxText}</h4>
              </DialogContentText>
            </DialogContent>
            <RaisedButton primary={true} onClick={this.props.handleBack.bind(this, this.state.advance_paid)} label="Re-Enter" />
          </Dialog>
        }
        <Dialog
          modal={false}
          open={this.state.confrmAmountDialog}
          onClose={() => this.setState({ confrmAmountDialog: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <h4 style={{ textAlign: 'center' }}>{this.state.confrmAmountDialogText}</h4>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button variant='contained' width="180" color='secondary' onClick={this.handleSubmitYes} >Yes</Button>
            <Button variant='contained' style={{ marginLeft: '15px' }} width="180" color='primary' onClick={() => this.setState({ confrmAmountDialog: false })}>No</Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.vendorWaringModal}
          onClose={() => this.setState({ vendorWaringModal: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <div style={{ textAlign: 'center', border: '1px dashed #FF0000' }}>
              <List>
                {this.state.vendorErrorObj.errors.map((error, index) => (
                  <ListItem key={error.name}>
                    <ListItemText style={{ minWidth: '240px' }} primary={error.name} />
                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                    <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={error.renderVal} />
                  </ListItem>
                ))}
              </List>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          open={this.state.approveDialogBox}
          onClose={this.handleNo}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="form-dialog-title">{this.state.approveddialogBoxTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.approveddialogBoxText}
            </DialogContentText>
            <TextField
              autoFocus
              onClick={this.clearErr.bind(this)}
              onChange={this.handleComment.bind(this)}
              helperText={this.state.commentErrText}
              error={this.state.commentErr}
              margin="dense"
              id="comment"
              label="*Comment"
              type="text"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleNo} color="primary">No</Button>
            <Button onClick={this.handleYes} color="primary" autoFocus>Yes</Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={this.state.snackOpen}
          autoHideDuration={1000}
          onClose={this.handleCloseSnack.bind(this)}
          message={this.state.snackText}
        />
      </MuiThemeProvider>
    )
  }
}
export default PreviewAndCalculations



// WEBPACK FOOTER //
// ./src/components/PreviewAndCalculations.js